import styled from "styled-components";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { Grid } from "@mui/material";
import { useLanguage } from "@/app/utils/LanguageContext";
import React, { useEffect, useState, useRef } from 'react';
import { useMyContext } from '@/app/utils/MyContext';
import "@/app/style/raceSelector2.scss";
import { RaceNo } from "@/app/utils/class/common/base";
//import { Swiper, SwiperSlide, useSwiper,  } from 'swiper/react';
//import SwiperCore from 'swiper/modules';
//import { Pagination, Navigation, Autoplay  } from 'swiper/modules';
//import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';

export type RaceSelectorData = {
    [venueCode: string]: { races: number[] };
}

type RaceSelectorProps = {
    type: string;
    //selectedRaceNo: number;
    //selectedVenueCode: string;
    handleSelectRace: (raceNo: RaceNo) => void;
    handleSelectMeeting: (index: number, mtg: any) => void
    //data?: any;
    enableAllBtn?: boolean;

    tabIdx: number;
    meetings: any;
    races: any;
    qidsRaces: any;
}

export default function RaceSelector2(props: RaceSelectorProps) {
    const { handleSelectRace, handleSelectMeeting, type: displayType, tabIdx, meetings, races, qidsRaces } = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [isMobile, setIsMobile] = useState(props.type == "mobile");

    const refMtg = useRef<HTMLDivElement | null>(null);
    const refRace = useRef<HTMLDivElement | null>(null);
    const isDraggingRef = useRef(false);

    //const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    //const [curSelectVenueCode, setCurSelectVenueCode] = useState(selectedVenueCode);
    const isResultPage = window.location.pathname.split('/').includes("results");
    useEffect(() => {
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (!isTouch && props.type == "mobile") setIsMobile(false);
    },[props.type])
    useEffect(() => {
        // if(tabIdx > 0){
        //     console.log('RaceSelector2 UpComingRaceCards---', myContextState.selectedMeetingVenueCode, myContextState?.selectedRaceNo?.valueOf?.())
        //     const tarRaceId = `${myContextState.selectedMeeting?.id}${myContextState.selectedMeetingVenueCode}-${myContextState?.selectedRaceNo}`
        //     //setcurrace(tarRaceId)

        //     const mtgIndex = meetings?.findLastIndex((i:any, idx: number) => idx == tabIdx);

        //     console.log('RaceSelector2 tarRaceIndex---', mtgIndex, meetings, swiperInstance, tabIdx)
        //     if (tabIdx > -1) {
        //         swiperInstance?.slideTo(tabIdx, 300)
        //     }
        // }  
        const curMtgCla =  document.getElementsByClassName("curMtg")?.[0] as HTMLElement;
        const curRaceCla =  document.getElementsByClassName("curRace")?.[0] as HTMLElement; 
        console.log('RaceSelector2 curMtg---', curMtgCla)
        //const mtgSlide = document.getElementById("MtgSlide"); 
        refMtg?.current?.scrollTo(
            {left: curMtgCla?.offsetLeft ?? 0, 
            behavior: "smooth"});

        refRace?.current?.scrollTo(
            {left: ((curRaceCla?.offsetLeft ?? 0) - (curRaceCla?.parentElement?.offsetLeft ?? 0)), 
             behavior: "smooth"});
    
    }, [meetings, tabIdx])

    useEffect(() => {
        const slider = refRace.current;

        if (!slider) return;

        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;

        const updateCursor = () => {
            const hasOverflow = slider.scrollWidth > slider.clientWidth;
            slider.style.cursor = hasOverflow ? "grab" : "default";
        };

        const handleMouseDown = (e: MouseEvent) => {
            const hasOverflow = slider.scrollWidth > slider.clientWidth;

            if (!hasOverflow) return;

            isDown = true;
            isDraggingRef.current = false;
            startX = e.pageX;
            scrollLeft = slider.scrollLeft;
            slider.style.cursor = "grabbing";
        };

        const handleMouseMove = (e: MouseEvent) => {
            if (!isDown) return;

            const walk = e.pageX - startX;

            if (Math.abs(walk) > 5) {
                isDraggingRef.current = true;
            }

            e.preventDefault();
            slider.scrollLeft = scrollLeft - walk;
        };

        const handleMouseUp = () => {
            if (!isDown) return;

            isDown = false;
            updateCursor();

            setTimeout(() => {
                isDraggingRef.current = false;
            }, 0);
        };

        updateCursor();

        slider.addEventListener("mousedown", handleMouseDown);
        slider.addEventListener("mousemove", handleMouseMove);
        slider.addEventListener("mouseup", handleMouseUp);
        slider.addEventListener("mouseleave", handleMouseUp);
        window.addEventListener("resize", updateCursor);

        return () => {
            slider.removeEventListener("mousedown", handleMouseDown);
            slider.removeEventListener("mousemove", handleMouseMove);
            slider.removeEventListener("mouseup", handleMouseUp);
            slider.removeEventListener("mouseleave", handleMouseUp);
            window.removeEventListener("resize", updateCursor);
        };
    }, [races]);

    const handleRaceItemClick = (
        e: React.MouseEvent,
        raceNo: RaceNo
    ) => {
        if (isDraggingRef.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        handleSelectRace(raceNo);
    };

    return (
        <Grid xs zeroMinWidth container className={`raceSelectorContainer1${displayType === "pc" ? " pc" : " mobile"}`} style={{padding: "0 0 0 12px"}}>
            {
                meetings && 
                <Grid item xs={12} sx={{display: 'flex', ...(displayType==="pc"&&{justifyContent: 'left'})}}>
                    <div ref={refMtg} id="MtgSlide" className={`stickyItem ${isMobile ? "mobile" : ""}`} >
                        {
                        meetings?.map((mtg: any, idx: number) => ( 
                            <div 
                                key={idx}
                                className={`headerItem ${idx == tabIdx && "selected curMtg"}`}
                                id="venue_code" 
                                onClick={() => handleSelectMeeting(idx, mtg)}>
                                    {mtg?.status ? <p>{t(`meetingBall${mtg?.meetingVenueCode}`) || "--"}</p> : <p>{mtg?.meetingVenueCode || "--"}</p>}
                            </div> 
                        )) 
                    }
                    </div> 
                    {(races && races?.length > 0) && <div className={`borderRight ${meetings?.length > 2 && displayType === "mobile" ? "sty " : ""}`}></div>}
                    
                    <div ref={refRace} className={`raceContent ${isMobile ? "mobile" : ""}`}> 
                    {
                        (isResultPage && displayType === "pc" && (races && races?.length > 0)) && <div className="raceItem" >
                            <div className={`headerItem ${myContextState.selectedRaceNo.valueOf()===-1 ? 'selected' : ''}`} onClick={(e) => handleRaceItemClick(e, new RaceNo(-1))}>
                                <p>{t('result_all')}</p>
                            </div>
                        </div>
                    }
                    {
                        races && races?.map((ra: any, i: number) => { 
                            const qRa = qidsRaces?.find((x: any) => x?.no == new RaceNo(ra?.displayName)?.valueOf());

                            return( <div key={i} className={ `raceItem ${myContextState.selectedRaceNo.isEqual(ra?.displayName) && "curRace"} ${qRa?.raceTrack?.description_en == "Turf" ? "turf" : (qRa?.raceTrack?.description_en ? "track" : "")}`}>
                                <div
                                    className={`headerItem ${myContextState.selectedRaceNo.isEqual(ra?.displayName) && "selected"} `}
                                    
                                    id={`raceSelect_no_${myContextState.selectedRaceNo}_${ra?.displayName}`}  
                                    onClick={(e) => (handleRaceItemClick(e, new RaceNo(ra?.displayName)))}
                                    >
                                    <p>{new RaceNo(ra?.displayName)?.valueOf()}</p>
                                </div>
                            </div>
                            )
                        })
                    } 
                    </div> 
                </Grid> 
            }
        </Grid>
    )
}